import { createFileRoute } from "@tanstack/react-router";
import { SandboxDetail } from "../../features/sandboxes/sandbox-detail";

export const Route = createFileRoute("/_authed/$org/$project/sandboxes/$name/$tab")({
  component: SandboxPage,
});

function SandboxPage() {
  const { org, project, name, tab } = Route.useParams();
  return <SandboxDetail scope={{ org, project }} name={name} tab={tab} />;
}
